import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import {
	StaticTextService,
	PricingService,
	NewOrderService,
	ConfigService,
	ProgressBarService,
	AuthService,
	ProductService,
	OrderListingService,
	AboutService
} from 'app/services';
import { CONSTANTS } from '../../app.constants';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
const {  required } = Validators;
import { AddressUtilsService } from '@services/address-utils/address-utils.service';

// declare var google: any;

@Component({
	selector: 'app-request-quote1',
	templateUrl: './request-quote1.component.html',
	styleUrls: ['./request-quote1.component.scss'],
})
export class RequestQuote1Component implements OnInit {
	quoteForm: UntypedFormGroup;
	selectedCriteria: any;
	quoteModel: any = {};
	selectedOption: number;
	checkAvlCounty: any;
	errors: any = {};
	fieldError = [];
	states = [];
	counties = [];
	selectedStates = [];
	products: any[] = [];
	googlePlaceState = '';
	latitude: any;
	longitude: any;
	timer: any;
	searchError: boolean = false;
	primaryColor = '#0F9D58';
	resetScreenData = true;
	input = '';
	showCityInCounty:boolean = false;
	allIndepdentCities : any;
	requestedTime: string = "17:00";
	orderReqtime = new UntypedFormControl({ value: '', disabled: true });
	todayDate = new Date();
	getDate = this.todayDate.setDate(this.todayDate.getDate() + 1);
	getUSDateString = new Date(this.getDate).toLocaleString("en-US", { timeZone: "America/New_York" });
    minDate = new Date(this.getUSDateString); 
	SearchDuration: any[] = [];
	constructor(
		private frmBuilder: UntypedFormBuilder,
		public text: StaticTextService,
		private pricingService: PricingService,
		private newOrder: NewOrderService,
		private config: ConfigService,
		private ref: ChangeDetectorRef,
		private progressServ: ProgressBarService,
		private router: Router,
		private auth: AuthService,
		private route: ActivatedRoute,
		private titleService: Title,
		private productService: ProductService,
		private orderListService: OrderListingService,
		private addressUtils: AddressUtilsService,
		private aboutService:AboutService
	) {
		this.quoteForm = frmBuilder.group({
			Order_Co_Buyer: [null, Validators.compose([Validators.maxLength(127)])],
			Order_Buyer: [null, Validators.compose([Validators.maxLength(127)])],
			Property_Address_1: [
				null,
				Validators.compose([Validators.required, Validators.maxLength(127)]),
			],
			Property_Address_2: [null, Validators.maxLength(127)],
			Property_City: [
				null,
				Validators.compose([Validators.required, Validators.maxLength(127)]),
			],
			Property_State_Abbr: new UntypedFormControl(
				{ value: null, disabled: false },
				Validators.required,
			),
			Property_County: new UntypedFormControl(
				{ value: null, disabled: false },
				Validators.required,
			),
			Property_ZipCode: [
				null,
				Validators.compose([Validators.required, Validators.maxLength(5)]),
			],
			Property_First_Name: [null, Validators.maxLength(127)],
			Property_Order_Number: [null, Validators.maxLength(255)],
			searchValue: [null],
			radioBtn: [null],
			Product_ID: [null,Validators.required],
			Years_Required: [null, Validators.compose([Validators.min(1), Validators.max(300), Validators.pattern('^[0-9]+$')])],
			Search_Duration: [1, Validators.required],
			Stop_At_Developer: [false],
			Order_Type: [null, Validators.required],
			Order_Parcel: [null, Validators.compose([Validators.maxLength(255)])],
			Order_Loan: [null, Validators.compose([Validators.maxLength(255)])],
			Order_Book: [null, Validators.compose([Validators.maxLength(255)])],
			Order_Page: [null, Validators.compose([Validators.maxLength(255)])],
			Order_Qualia_Internal_ID: [
				null,
				Validators.compose([Validators.maxLength(127)]),
			  ],
			  Property_Cust_File_Number: [
				null,
				Validators.compose([Validators.maxLength(127)]),
			  ],
			  Property_Order_Purpose: [
				null,
				Validators.compose([Validators.maxLength(127)]),
			  ],
			  Order_Mortgage_Amount: [
				null,
				Validators.compose([Validators.maxLength(14)]),
			  ],
			  Order_Mortgage_Date: [{ disabled: false, value: "" }],
			  Order_Subdivision: [null, Validators.compose([Validators.maxLength(255)])],
			  Order_Requested_Date: [{ disabled: false, value: "" }],
		});
	}

	ngOnInit() {
		this.titleService.setTitle(`Pippin Title™ - Client - Quote (New)`)
		this.auth.getHubSpotTokenDetails();
		this.auth.loadHubSpotChatToken();
		this.resetQuoteData();
		this.fetchProducts();
		this.getCountyForIndependCity();
		this.progressServ.setPrimaryColor(this.primaryColor);
		this.progressServ.setHeight(2);
		this.progressServ.setStage(0);
		this.progressServ.setTotalStages(3);
		this.progressServ.setProgressState((0 / 3) * 100);
		this.progressServ.setBarType(1);
		this.pricingService.getStateList().subscribe(states => {
			if (states) {
				var tempStates = [];
				states.forEach(state =>
					tempStates.push({ State_Short_Name: state[0].toUpperCase() }),
				);
				this.states = tempStates;
				this.selectedStates = tempStates;
			}
		});

		this.quoteModel.Product_ID = null;    //can put variable with custom search value here
		this.quoteModel.Property_State_Abbr = '';
		this.quoteModel.orderDocs = [];
		this.quoteModel.orderDocId = [];
		this.quoteModel.Search_Duration=1;
		this.quoteModel.Stop_At_Developer=false;
		this.populateSearchDurationList();
		if (this.newOrder.searchType) {
			this.selectedOption = this.newOrder.searchMode;
		} else {
			this.selectedOption = 1;
		}

		this.selectedCriteria = this.newOrder.searchCriteria;

		if (this.newOrder.quoteData) {
			this.quoteModel = Object.assign({}, this.newOrder.quoteData);
			this.quoteModel.Stop_At_Developer = Boolean(this.quoteModel.Stop_At_Developer);
			if(this.quoteModel.Order_Requested_Time) this.requestedTime = this.quoteModel.Order_Requested_Time;
			this.resetScreenData = false;
			this.latitude = this.quoteModel.Property_Latitude;
			this.longitude = this.quoteModel.Property_Longitude;
			this.ref.detectChanges();
		}

		this.timer = setTimeout(() => this.config.setSideBarNode(0), 0);

		this.quoteForm.get('Product_ID')?.valueChanges.subscribe((productId: number) => {
			const selectedProduct = this.products.find(p => p.Product_ID === productId);
			if (selectedProduct) this.quoteModel.Product_Description = selectedProduct.Product_Description;
		});
	}

	resetQuoteData() {
		if (!this.route.snapshot.params['back']) this.newOrder.resetQuoteData();
	}

	clearErrors() {
		this.errors = {};
		this.fieldError = [];
	}

	changeCriteria(){
		if(this.selectedCriteria == 1 || this.selectedCriteria == 3 ){
		  this.quoteForm.controls['Order_Buyer'].clearValidators();
		  this.quoteForm.controls['Order_Buyer'].setValidators([Validators.maxLength(127)])
		  this.quoteForm.controls['Order_Buyer'].updateValueAndValidity();
		}else{
		  this.quoteForm.controls['Order_Buyer'].setValidators([Validators.required, Validators.maxLength(127)])
		  this.quoteForm.controls['Order_Buyer'].updateValueAndValidity();
		}
		this.showCityInCounty = false;
	  }
	
	detectTypeChange(event) {
		this.counties = [];
		this.checkAvlCounty = null;
		this.quoteForm.controls['searchValue'].reset();
		this.quoteForm.controls['Property_Address_1'].reset();
		this.quoteForm.controls['Property_Address_2'].reset();
		this.quoteForm.controls['Property_City'].reset();
		this.quoteForm.controls['Property_State_Abbr'].reset();
		this.quoteForm.controls['Property_County'].reset();
		this.quoteForm.controls['Property_ZipCode'].reset();
	}

	clearValid(control) {
		control.markAsUntouched();
	}

	ngAfterViewInit() {
		// let searchBox: any = document.getElementById('search-box');
		// let options = {
		// 	types: [
		// 		// return only geocoding results, rather than business results.
		// 		'geocode',
		// 	],
		// };
		// var autocomplete = new google.maps.places.Autocomplete(searchBox, options);
		
		// // Add listener to the place changed event
		// autocomplete.addListener('place_changed', () => {
		// 	this.getPlaceDetails(autocomplete.getPlace());
		// });
	}

	protected get userId() {
		return this.auth.getUserOrgId() || this.auth.getUserId();
	}


	fetchProducts(){
			this.orderListService.getOrderProductsForClient(this.userId).subscribe((fetchedProducts) => {
			this.products = fetchedProducts;
		})
	}

	getPlaceDetails(place: any) {
		this.quoteModel.searchValue = '';
		this.clearErrors();

		if (place == undefined) {
			this.quoteModel.Property_City = '';
			this.quoteModel.Property_State_Abbr = '';
			this.quoteModel.Property_ZipCode = '';
			this.quoteModel.Property_County = '';
			this.checkAvlCounty = '';
			this.searchError = true;
			return;
		} else {
			this.searchError = false;
			this.latitude = place.location.lat;
			this.longitude = place.location.lng;
			this.quoteModel.Property_Address_1 = '';
			this.quoteModel.Property_City = '';
			this.quoteModel.Property_State_Abbr = '';
			this.quoteModel.Property_ZipCode = '';
			this.quoteModel.Property_County = '';
			this.checkAvlCounty = '';

			for (let i = place.addressComponents.length - 1; i >= 0; i--) {
				switch (place.addressComponents[i].types[0]) {
					case 'premise':
						this.quoteModel.Property_Address_1 =
							place.addressComponents[i].longText +
							' ' +
							this.quoteModel.Property_Address_1;
						document
							.getElementById('Property_Address_1')
							.parentElement.classList.remove('is-empty');
						break;
					case 'street_number':
						this.quoteModel.Property_Address_1 =
							place.addressComponents[i].longText +
							' ' +
							this.quoteModel.Property_Address_1;
						document
							.getElementById('Property_Address_1')
							.parentElement.classList.remove('is-empty');
						break;
					case 'route':
						this.quoteModel.Property_Address_1 = place.addressComponents[i].longText;
						document
							.getElementById('Property_Address_1')
							.parentElement.classList.remove('is-empty');
						break;
					case 'sublocality_level_1':
						if (this.quoteModel.Property_City.length == 0)
							this.quoteModel.Property_City = place.addressComponents[i].longText;
						document
							.getElementById('Property_City')
							.parentElement.classList.remove('is-empty');
						break;
					case 'sublocality':
						if (this.quoteModel.Property_City.length == 0)
							this.quoteModel.Property_City = place.addressComponents[i].longText;
						document
							.getElementById('Property_City')
							.parentElement.classList.remove('is-empty');
						break;
					case 'locality':
						if (this.quoteModel.Property_City.length == 0)
							this.quoteModel.Property_City = place.addressComponents[i].longText;
						document
							.getElementById('Property_City')
							.parentElement.classList.remove('is-empty');
						break;
					case 'administrative_area_level_2': {
						if (this.checkSaint(place.addressComponents[i].longText)) this.checkCountyNReplace(place, i)
						else this.checkCountyNReplace(place, i)
						this.checkAvlCounty = place.addressComponents[i].longText.toUpperCase();
						break;
					}
					case 'administrative_area_level_1': {
						this.googlePlaceState = place.addressComponents[i].shortText;
						this.quoteForm.controls['Property_State_Abbr'].setValue(
							place.addressComponents[i].shortText,
						);
						if (place.addressComponents[i].shortText == 'DC')
							this.checkAvlCounty = 'WASHINGTON';
						break;
					}
					case 'postal_code':
						this.quoteModel.Property_ZipCode = place.addressComponents[i].shortText;
						break;
					case 'country':
						this.quoteModel.Country = place.addressComponents[i].shortText;
						break;
					default:
						break;
				}
			}
			this.quoteModel.Property_City = this.addressUtils.resolveDisplayCity(place.addressComponents, place.formattedAddress);
			if (this.checkIfState(this.quoteModel.Property_State_Abbr, this.quoteModel.Country)){
                if(!this.checkAvlCounty){
					this.checkIfCityIsIndependent()
                    this.showCityInCounty = true;
                  } else this.showCityInCounty = false;
            }
            else {
                this.quoteModel.Property_State_Abbr = '';
                this.quoteModel.Property_County = '';
                this.quoteModel.Country = '';
                this.errors['State'] = true;
                this.errors['County'] = true;
            }
			this.ref.detectChanges();
		}
	}
	
	checkCountyNReplace(place, i) {
		place.addressComponents[i].longText = place.addressComponents[i].longText.replace(' County', '');
	}

	checkSaint(county) {
		
		var lowecaseCounties = CONSTANTS.saintArray.map(value => value.toLowerCase());
		if (
			county.toLowerCase().startsWith('st.') &&
			lowecaseCounties.indexOf(county.toLowerCase()) == -1
		)
			return true;
		else return false;
	}

	checkIfState(stateName, country) {
		//var states = _.flatten(this.states);
		if (
			country == 'US' &&
			this.states.findIndex(
				state => state.State_Short_Name.toLowerCase() == stateName.toLowerCase(),
			) > -1
		)
			return true;
		else return false;
	}

	clearFormsEvent(event) {
		if (event) this.getCountyList(event);
		if (this.quoteModel.Property_State_Abbr) delete this.errors.State;
	}

	getCountyList(event) {
		if (event) {
			if (this.checkAvlCounty || this.checkAvlCounty == '') {
				if (this.quoteModel.Property_County) this.quoteModel.Property_County = null;
			}
			this.pricingService
				.getCountyList(this.quoteModel.Property_State_Abbr)
				.subscribe(counties => {
					this.counties = counties;
					let avlCountyName = [];
					this.counties.forEach(county =>
						avlCountyName.push(county.County_Name.toUpperCase()),
					);
					if(this.showCityInCounty) this.quoteModel.Property_County = this.checkAvlCounty
                    else {
                        if (avlCountyName.indexOf(this.checkAvlCounty) > -1)
                        this.quoteModel.Property_County = this.checkAvlCounty;
                    }
					this.ngAfterViewInit();
					this.ref.detectChanges();
				});
		}
	}

	clearCountyError() {
		if (this.quoteModel.Property_County) delete this.errors.County;
	}

	detectManualChange() {
		this.quoteModel.Property_County = null;
	}

	getIfErrors() {
		if (Object.keys(this.errors).length) return true;
		else return false;
	}

	validateForm() {
		this.errors = {};
		if (!this.quoteModel.Product_ID) this.errors['Product'] = true;
		if (!this.quoteModel.Property_State_Abbr) this.errors['State'] = true;
		if (!this.quoteModel.Property_County) this.errors['County'] = true;
		if (this.selectedCriteria == 1) {
			if (!this.quoteModel.Property_Address_1) this.errors['Property Address'] = true;
			if (!this.quoteModel.Property_City) this.errors['City'] = true;
			if (!this.quoteModel.Property_ZipCode) this.errors['ZipCode'] = true;
		} else if (this.selectedCriteria == 2) {
			if (!this.quoteModel.Order_Buyer) this.errors['Buyer'] = true;
		} else if (this.selectedCriteria == 3) {
			if (!this.quoteModel.Order_Parcel) this.errors['Parcel'] = true;
		}

		if (Object.keys(this.errors).length == 0) this.goToRequestQuoteStep2();
		else {
			this.fieldError = Object.keys(this.errors);
		}
	}

	getFormGrpvalidation() {
		var flag = false;
		switch (this.selectedCriteria) {
			case 1:
				if (this.quoteForm.controls['Property_Address_1'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_Address_2'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_City'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_ZipCode'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_State_Abbr'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_County'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_First_Name'].invalid) flag = true;
				else if (this.quoteForm.controls['Product_ID'].invalid) flag = true;
				else if (this.quoteForm.controls['Years_Required'].invalid) flag = true;
				break;
			case 2:
				if (this.quoteForm.controls['Order_Buyer'].invalid) flag = true;
				else if (this.quoteForm.controls['Order_Co_Buyer'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_State_Abbr'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_County'].invalid) flag = true;
				else if (this.quoteForm.controls['Product_ID'].invalid) flag = true;
				else if (this.quoteForm.controls['Years_Required'].invalid) flag = true;
				break;
			case 3:
				if (this.quoteForm.controls['Order_Book'].invalid) flag = true;
				else if (this.quoteForm.controls['Order_Loan'].invalid) flag = true;
				else if (this.quoteForm.controls['Order_Page'].invalid) flag = true;
				else if (this.quoteForm.controls['Order_Parcel'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_State_Abbr'].invalid) flag = true;
				else if (this.quoteForm.controls['Property_County'].invalid) flag = true;
				else if (this.quoteForm.controls['Product_ID'].invalid) flag = true;
				else if (this.quoteForm.controls['Years_Required'].invalid) flag = true;
				break;
			default:
				flag = false;
				break;
		}
		return flag;
	}

	goToRequestQuoteStep2() {
		this.quoteModel.Organization_ID = this.auth.getUserOrgId();
		this.quoteModel.Property_Latitude = this.latitude;
		this.quoteModel.Property_Longitude = this.longitude;
		this.quoteModel.independent_City = this.showCityInCounty;
		this.quoteModel.Order_Requested_Time = this.requestedTime;
		this.newOrder.quoteData = this.quoteModel;
		this.newOrder.searchCriteria = this.selectedCriteria;
		this.newOrder.searchMode = this.selectedOption;
		this.router.navigate(['/quote/' + this.auth.getUserId() + '/step2']);
	}

	goBack() {
		this.router.navigate(['/orders/current']);
	}

	clearForms() {
		if (this.resetScreenData) {
			this.errors = {};
			this.counties = [];
			this.checkAvlCounty = null;
			this.quoteForm.controls['Property_First_Name'].reset();
			this.quoteForm.controls['Property_Address_1'].reset();
			this.quoteForm.controls['Property_Address_2'].reset();
			this.quoteForm.controls['Property_City'].reset();
			this.quoteForm.controls['Property_ZipCode'].reset();
			this.quoteForm.controls['Property_State_Abbr'].reset();
			this.quoteForm.controls['Property_County'].reset();
			this.quoteForm.controls['Order_Buyer'].reset();
			this.quoteForm.controls['Order_Co_Buyer'].reset();
			this.quoteForm.controls['Order_Parcel'].reset();
			this.quoteForm.controls['Order_Loan'].reset();
			this.quoteForm.controls['Order_Book'].reset();
			this.quoteForm.controls['Order_Page'].reset();
			this.quoteForm.controls["Property_Cust_File_Number"].reset();
			this.quoteForm.controls["Property_Order_Purpose"].reset();
			this.quoteForm.controls["Order_Mortgage_Amount"].reset();
			this.quoteForm.controls["Order_Mortgage_Date"].reset();
			this.quoteForm.controls["Order_Subdivision"].reset();
			this.quoteForm.controls["Order_Requested_Date"].reset();
			this.quoteForm.controls["Product_ID"].reset();
			this.requestedTime = "17:00";
			this.fieldError = [];
		} else this.resetScreenData = true;
	}

	sanitizeAmountInput(event: Event, model: any, fieldName: string): void {
		const input = event.target as HTMLInputElement;

		// 1. Remove all characters except digits and the first decimal point
		let raw = input.value.replace(/[^0-9.]/g, '');
		const parts = raw.split('.');
		if (parts.length > 2) {
			raw = parts[0] + '.' + parts.slice(1).join('');
		}

		// 2. Restrict to 2 decimal places
		const match = raw.match(/^(\d+)(\.\d{0,2})?/);
		const formatted = match ? match[1] + (match[2] || '') : '';

		const valueToSet = formatted === '' ? null : formatted;

		// 3. Update input DOM, model, and form control
		input.value = formatted;
		model[fieldName] = valueToSet;
		this.quoteForm.controls[fieldName].setValue(valueToSet, { emitEvent: false });
	}

	sanitizeNumericInput(event: Event, model: any, fieldName: string): void {
		const input = event.target as HTMLInputElement;
		const sanitized = input.value.replace(/[^0-9]/g, '');

		const valueToSet = sanitized === '' ? null : sanitized;
		input.value = sanitized;
		model[fieldName] = valueToSet;
		this.quoteForm.controls[fieldName].setValue(valueToSet, { emitEvent: false });
	}

	getCountyForIndependCity = (state?: string) => {
		this.pricingService.getIndpendentCities()
		.subscribe((cities) => {
			this.allIndepdentCities = cities;
		})
	};

	checkIfCityIsIndependent() {
	let findCityIndex = this.allIndepdentCities.findIndex((city) => {
		if(city) return this.quoteModel.Property_City.toLowerCase() === city.System_Independent_City.toLowerCase()
		else return false;
	})
	if(findCityIndex > -1 ) {
		if(this.allIndepdentCities[findCityIndex].System_Independent_City_Custom_Name) this.checkAvlCounty = this.allIndepdentCities[findCityIndex].System_Independent_City_Custom_Name.toUpperCase();
		else this.checkAvlCounty = this.quoteModel.Property_City.toUpperCase();
	}else this.checkAvlCounty = this.quoteModel.Property_City.toUpperCase();
	}

	handleChangeMortgageDate(event) {
	}
	handleChangeRequestedDate(event) {
	}
	reqDateChange() {
		this.errors = {};
		if (this.quoteModel.Order_Requested_Date) this.orderReqtime.enable();
		else this.orderReqtime.disable();
	  }

	

	populateSearchDurationList(){
    this.orderListService.getSearchDurationList().subscribe((response)=>{
      this.SearchDuration=response;
    });
  }
}
